<template>
<div>
  <nav class="navbar navbar-light bg-white hide-empty px-5 py-3">
    <slot name="context-actions"></slot>
  </nav>
  <div class="px-5 py-5">
    <slot></slot>
  </div>
</div>
</template>
<script>
export default {
  data: function () {
    return {};
  },
  methods: {},
};
</script>

<style scoped></style>
